import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { Background } from './Background';
import { FADE, MAX_LEADERS } from '../../HOME/const';
import LeaderItem from '../../HOME/COMPONENTS/LeaderItem';
import { setUserId } from '../../HOME/REDUX/actions';
import { showLeaderboards } from '../../HOME/REDUX/actions';
import LeaderBase from '../../HOME/COMPONENTS/LeaderBase';
import BackButton from './BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { getDate, scrollClass } from '../../HOME/utils';
import _ from 'lodash';
import { NM_BACKGROUND } from '../const';

class Leaderboard extends LeaderBase {
  state = {
    ...this.state,
    score: this.props.stats ? this.props.stats.score : 0,
  };

  componentDidMount() {
    this.init(() => {
      this.getCachedLeaders(true);

      const { bestScore, plays } = this.props.stats || {};
      this.setState({ score: bestScore, plays });
    });
  }

  getQuery = () => {
    return this.leaders
      .orderBy('score', 'desc')
      .orderBy('plays', 'desc')
      .limit(MAX_LEADERS);
  };

  cacheKey() {
    return `${this.props.app} LEADERS`;
  }

  userKey(id) {
    id = id || this.props.uid;
    return id;
  }

  dataToSubmit = () => {
    const { score, plays } = this.state;
    return { name: this.state.name.trim(), score, plays, date: getDate() };
  };

  renderNavigation = () => (
    <>
      <BackButton />
      <HomeButton />
    </>
  );

  render() {
    const rankColor = 'rgb(200, 150, 200)';
    const background = NM_BACKGROUND;
    const submitColor = NM_BACKGROUND;
    const scoreAlias = 'Best';

    return (
      <>
        <div className={`leaders-screen ${this.props.showLeaders === FADE ? 'fadeout' : ''}`}>
          {this.renderClickableScreen()}
          <div className="leaders fadein-fast" style={{ background, backgroundImage: Background, color: 'white' }}>
            <div className={scrollClass} style={{ gridArea: '2/1', display: 'initial' }}>
              {_.map(this.state.users, (u, i) => (
                <LeaderItem key={i} rank={i + 1} data={u.data} rankColor={rankColor} scoreAlias={scoreAlias} />
              ))}
            </div>
            {this.renderCommon(rankColor, submitColor, scoreAlias)}
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({ nm, common }) {
  return { ...nm, ...common };
}

export default connect(
  mapStateToProps,
  { setUserId, showLeaderboards }
)(Leaderboard);
